// Module
var code = "<button title=\"Scroll to top\" type=\"button\" aria-label=\"Scroll to top\"></button> ";
// Exports
export default code;